import Vue from 'vue'
import Router from 'vue-router'

// import Index from '@/pages/index'
const index = () =>
  import ("../pages/index.vue")
const login = () =>
  import ("../pages/login.vue")
const regist = () =>
  import ("../pages/regist.vue")
const list = () =>
  import ("../pages/list.vue")
const polyphenol = () =>
  import ("../pages/polyphenol.vue")
const compare = () =>
  import ("../pages/compare.vue")
const center = () =>
  import ("../pages/center.vue")
const detail = () =>
  import ("../pages/detail.vue")
Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'index',
    component: index
  }, {
    path: '/login',
    name: 'login',
    component: login
  }, {
    path: '/regist',
    name: 'regist',
    component: regist
  }, {
    path: '/list',
    name: 'list',
    component: list
  }, {
    path: '/polyphenol',
    name: 'polyphenol',
    component: polyphenol
  }, {
    path: '/compare',
    name: 'compare',
    component: compare
  }, {
    path: '/center',
    name: 'center',
    component: center
  }, , {
    path: '/detail',
    name: 'detail',
    component: detail
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js